var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ClassBaseDirective } from '../../component/base/classbase.directive';
import { ClassService } from '../../service/class.service';
import { Btn } from '../../models/button/button';
var ButtonDirective = /** @class */ (function (_super) {
    __extends(ButtonDirective, _super);
    function ButtonDirective(el, renderer, service) {
        var _this = _super.call(this, el, renderer, service) || this;
        _this.el = el;
        _this.renderer = renderer;
        _this.service = service;
        _this.btn = new Btn();
        return _this;
    }
    ButtonDirective.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ButtonDirective.prototype.onInit = function () {
        _super.prototype.onInit.call(this);
        if (this.key === 'remodalBtn' && this.tag === 'button') {
            _super.prototype.addClass.call(this, 'remodal_btns_group-ok');
        }
        if (this.btn.params && this.btn.params.btnClass) {
            var btn = this.btn.params.btnClass;
            if (this.tag === 'li') {
                if (typeof btn.width !== 'undefined' && btn.width) {
                    _super.prototype.addClass.call(this, 'btns_li-w' + btn.width);
                }
            }
            else if (this.tag === 'button') {
                if (typeof btn.sm !== 'undefined' && btn.sm === true) {
                    _super.prototype.addClass.call(this, 'btn-sm');
                }
                if (typeof btn.xs !== 'undefined' && btn.xs === true) {
                    _super.prototype.addClass.call(this, 'btn-xs');
                }
                if (typeof btn.type !== 'undefined' && btn.type) {
                    if (this.key === 'btn') {
                        _super.prototype.addClass.call(this, 'btn-' + btn.type);
                    }
                    else if (this.key === 'remodalBtn') {
                        _super.prototype.removeClass.call(this, 'remodal_btns_group-ok');
                        _super.prototype.addClass.call(this, 'remodal_btns_group-' + btn.type);
                    }
                }
            }
        }
        if (this.btn.params && this.btn.params.addClass) {
            var add = jsonpath.value(this.btn.params.addClass, '$.' + this.tag);
            if (add) {
                _super.prototype.addClass.call(this, add);
            }
        }
    };
    ButtonDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[buttonDir]'
                },] }
    ];
    /** @nocollapse */
    ButtonDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ClassService }
    ]; };
    ButtonDirective.propDecorators = {
        btn: [{ type: Input }]
    };
    return ButtonDirective;
}(ClassBaseDirective));
export { ButtonDirective };
//# sourceMappingURL=button.directive.js.map